import { VALIDATION_MESSAGES } from "./constantValidationMessages";

const validateField = (name, value, formData) => {
    let error = "";
    switch (name) {
      case "email":
        if (!value.trim()) {
          error = VALIDATION_MESSAGES.EMAIL_REQUIRED
        } else if (!/\S+@\S+\.\S+/.test(value)) {
          error = VALIDATION_MESSAGES.EMAIL_VALID
        }
        break;
      case "password":
        if (!value.trim()) {
          error = VALIDATION_MESSAGES.PASSWORD_REQUIRED
        } else if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/.test(value)) {
          error = VALIDATION_MESSAGES.PASSWORD_VALID
        }
        break;
      case "confirmPassword":
        if (!value.trim()) {
          error =VALIDATION_MESSAGES.CONFIRM_PASSWORD_REQUIRED
        } else if (value !== formData.password) {
          error = VALIDATION_MESSAGES.CONFIRM_PASSWORD_VALID
        }
        break;
      case "phone":
        if (!value.trim()) {
          error = VALIDATION_MESSAGES.PHONE_NUMBER_REQUIRED
        } else if (!/^\d{10}$/.test(value)) {
          error = VALIDATION_MESSAGES.PHONE_VALID
        }
        break;
      // Add validation for other fields here
      default:
        break;
    }
    return error;
  };
  export default validateField